<template>
  <section class="py-4">
    <v-container>
      <div class="embed-responsive mx-auto">
        <iframe
          src="//speakerdeck.com/player/38e763d3eb6b4c73af9b918e75054d61"
          frameborder="0"
          allowtransparency="true"
          allowfullscreen="allowfullscreen"
          mozallowfullscreen="true"
          webkitallowfullscreen="true"/>
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'introduction',
}
</script>

<style lang="scss">

.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  max-width: 700px;
  padding: 0;
  overflow: hidden;
  &::before {
    display: block;
    content: "";
    padding-top: 75%;
  }
  > iframe {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0; 
  }
}

</style>
